import { EditOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import { DataGrid, GridActionsCellItem, GridToolbar } from '@mui/x-data-grid'
import { ScopeRequirementAll, SCOPES } from 'components'
import dayjs from 'dayjs'

export const AllReportsTable = ({ isLoading, rows, onEdit }) => {
  const COLUMNS = [
    {
      field: 'Revision',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        return value ?? 0
      }
    },
    {
      field: 'Type',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        return value ?? '--'
      }
    },
    {
      field: 'Title',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        return value ?? '--'
      }
    },
    {
      field: 'DateOfVisit',
      headerName: 'Date of visit',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        if (!value) {
          return '--'
        }
        return dayjs(value).format('DD/MM/YYYY')
      }
    },
    {
      field: 'createdAt',
      headerName: 'Report date',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        if (!value) {
          return '--'
        }
        return dayjs(value).format('DD/MM/YYYY')
      }
    },
    {
      field: 'Company',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        if (!value) {
          return '--'
        }
        return value
      }
    },
    {
      field: 'Site',
      flex: 1,
      hideable: false,
      disableColumnMenu: true,
      valueGetter: (value) => {
        if (!value) {
          return '--'
        }
        return value
      }
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 100,
      cellClassName: 'actions',
      getActions: ({ row }) => {
        return [
          <ScopeRequirementAll requirements={[SCOPES.reporting.Write]} siteId={row?.SiteId} key="edit">
            <GridActionsCellItem icon={<EditOutlined />} label="Edit" color="inherit" onClick={() => onEdit(row)} />
          </ScopeRequirementAll>
        ]
      }
    }
  ]

  return (
    <Box
      sx={{
        marginBottom: '4em !important'
      }}>
      <DataGrid
        loading={isLoading}
        showCellVerticalBorder={false}
        getRowId={(data) => {
          return data.id
        }}
        disableMultipleRowSelection
        rows={rows}
        editMode="row"
        columns={COLUMNS}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            csvOptions: {
              allColumns: true
            }
          },
          loadingOverlay: {
            variant: 'skeleton',
            noRowsVariant: 'skeleton'
          }
        }}
      />
    </Box>
  )
}
